import { createBrowserRouter } from "react-router-dom";
import { AdminAuditLogs } from "../admin/AdminAuditLogs";
import { AdminDashboard } from "../admin/AdminDashboard";
import { AdminLayout } from "../admin/AdminLayout";
import { AdminRequestDetail } from "../admin/AdminRequestDetail";
import { AdminRequests } from "../admin/AdminRequests";
import { PublicLayout } from "../components/PublicLayout";
import { Contact } from "../pages/Contact";
import { Coverage } from "../pages/Coverage";
import { Home } from "../pages/Home";
import { Leadership } from "../pages/Leadership";
import { Methodology } from "../pages/Methodology";
import { NotFound } from "../pages/NotFound";
import { Privacy } from "../pages/Privacy";
import { Reports } from "../pages/Reports";
import { RequestEvaluation } from "../pages/RequestEvaluation";
import { Services } from "../pages/Services";
import { Terms } from "../pages/Terms";
import { ValuationUnit } from "../pages/ValuationUnit";

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/valuation-unit", element: <ValuationUnit /> },
      { path: "/services", element: <Services /> },
      { path: "/methodology", element: <Methodology /> },
      { path: "/reports", element: <Reports /> },
      { path: "/coverage", element: <Coverage /> },
      { path: "/leadership", element: <Leadership /> },
      { path: "/request-evaluation", element: <RequestEvaluation /> },
      { path: "/contact", element: <Contact /> },
      { path: "/privacy", element: <Privacy /> },
      { path: "/terms", element: <Terms /> },
    ],
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "requests", element: <AdminRequests /> },
      { path: "requests/:id", element: <AdminRequestDetail /> },
      { path: "audit-logs", element: <AdminAuditLogs /> },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
